import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-articale-service',
  templateUrl: './articale-service.component.html',
  styleUrls: ['./articale-service.component.css'],
})
export class ArticaleServiceComponent {
  
  @Input() data!: any;
  @Input() language!: string;

  constructor() {}  

} 
